import styled from 'styled-components';

const Wrapper = styled.div`
  font-family: "Noto Sans Thai", sans-serif;
  min-height: 100vh;
  background: #fff;
  margin: 0;
  padding: 0;
`;

function PageWrapper({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

export default PageWrapper;